export function buildCards(cards) {
  return cards.map((card) => {
    return {
      id: card.id,
      idProject: card.attributes.project?.id
        ? card.attributes.project.id
        : card.id,
      name: card.attributes.project
        ? card.attributes.project.name
        : card.attributes.name,
      protocol: card.attributes.project
        ? card.attributes.project.protocol
        : card.attributes.protocol,
      description: card.attributes.project
        ? card.attributes.project.description
        : card.attributes.description,
      dateEnd: card.attributes.project
        ? card.attributes.project.dateEnd
        : card.attributes.dateEnd,
      users: card.attributes.users,
      networks: card.attributes.project
        ? card.attributes.project.networks
        : card.relationships.networks?.data.map((network) => network.id),
      tasks: card.attributes.project
        ? card.attributes.project.tasks
        : card.relationships.tasks?.data,
      step: card.relationships.step.data.id,
    };
  });
}

export function defaultBody({ MODEL, body, id }) {
  const dataBody = {
    data: {
      type: MODEL,
      attributes: body,
    },
  };
  dataBody.data.id = id && id;
  return dataBody;
}

